import { Component, Inject, Input, OnInit } from '@angular/core';
import { Signature } from '../../../../../models/signature';
import { DOCUMENT } from '@angular/common';
import { SignatureMessages } from '../../../../shared/models/component-messages/signature-messages';
import { SignatureHelper } from '../../../helpers/signature-helper';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements OnInit {

  @Input() signature: Signature;
  @Input() signatureIndex;
  public arrowID: string;
  public isShow: boolean;
  public openById = {};
  public activeIds = ['first-panel'];
  public relatedInformation: string;
  public signatureMessages = new SignatureMessages();

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  public ngOnInit() {
    this.arrowID = 'arrow_';
    const relatedInformationArray: string[] = [];
    relatedInformationArray.push(this.signature.properties.relatedInformations.reason);
    relatedInformationArray.push(this.signature.properties.relatedInformations.location);
    relatedInformationArray.push(this.signature.properties.relatedInformations.oidSignaturePolicy);
    this.relatedInformation = relatedInformationArray.filter(str => str !== undefined).join('\n');
    let i = 0;
    this.signature.errors.forEach(err => {
      this.signature.errors[i++] = err + '\n';
    });
  }

  /**
   * return state of accordion, if accordion is open then it return true
   * @param eventSign get status of accordion
   */
  public isOpen(eventSign) {
    this.openById[eventSign.panelId] = eventSign.nextState;
    this.isShow = this.openById[eventSign.panelId];
  }

  public getSignatureLevel(value): string {
    return SignatureHelper.getSignatureLevel(value);
  }

  public getSignatureFormat(value): string {
    return SignatureHelper.getSignatureFormat(value);
  }
}
